import { useCallback, useState } from 'react';
import { useChainId } from 'src/hooks/chain';
import { useChangesSnackbar } from 'src/hooks/snackbar/useChangesSnackbar';
import { DeleteChainFurnitureInput } from 'src/infrastructure/rest-api/api-types';
import { buildApiUrl, useApiMutation } from 'src/infrastructure/rest-api/useApi';

export const useInventoryMasterDataDeleteChanges = () => {
    const chainId = useChainId();
    const showSnackbar = useChangesSnackbar();
    const [isUpdating, setIsUpdating] = useState(false);

    const [deleteFurniture] = useApiMutation('/api/inventorymanagement/chains/{chainId}', 'delete', {
        update: (_data, variables, queryClient) => {
            queryClient.invalidateQueries({
                queryKey: [buildApiUrl('/api/inventorymanagement/chains/{chainId}', variables.path)],
            });
        },
    });

    const deleteChanges = useCallback(
        async (input: DeleteChainFurnitureInput) => {
            if (!input?.id) return;
            setIsUpdating(true);

            try {
                const response = await deleteFurniture({ path: { chainId: chainId }, body: input });
                showSnackbar();
                return response;
            } catch (err: unknown) {
                showSnackbar(err);
            } finally {
                setIsUpdating(false);
            }
        },
        [deleteFurniture, showSnackbar, chainId]
    );

    return [deleteChanges, { loading: isUpdating }] as const;
};
